import React, { memo, useEffect, useState } from "react";
import { DE } from '../../../Languages/DE';
import { EN } from '../../../Languages/EN';
import LanguageContext from "../../../helper/LanguageContext";
import { BASE_URL } from "../../../helper/constants";
import MaterialIcon from "../../../components/MaterialIcon";
import { callAPI } from "../../../helper/apiUtils";
import { convertPosition } from "../../../helper/convertor";
import { ListGroup, Modal } from 'react-bootstrap';
import { Positions } from "../../../Languages/vars/Positions";
import { $crud } from "../../../helper/CrudFactory";
import { $user } from "../../../helper/UserFactory";
import { connect, useDispatch } from "react-redux";
import { store, UPDATE_PROJECT_ACTION_FIRE, SET_ACTIVITY_MESSAGES_LAST_FETCHED } from "../../../store";
import { withRouter } from "react-router-dom";
import UserAvatar from "../../../components/UserAvatar";
import "./RejoinUsersDialoge.css";

function RejoinUsersDialoge({ handleClose, companyRequests }) {
    const { isGerm, strings } = React.useContext(LanguageContext)
    const dispatch = useDispatch();
    const [users, setUsers] = useState([])
    const [Myusers, setMyUsers] = useState([])
    const [selectedUser, setSelectedUser] = useState(null)
    const [isShowCompany, setIsShowCompany] = useState(null)
    const [isShowME, setIsShowME] = useState(null)
    const [employeePosition, setEmployeePosition] = useState();
    const user = $user.get();
    useEffect(() => {
        let forME = companyRequests.filter(e => {
            return (e.buildingUser.findIndex(j => (j == user.id)) || e.buildingUser.findIndex(j => (j == user.id)) == 0)
        })
        setMyUsers(forME)
        if (forME.length > 0) {
            setIsShowCompany(false)
            setIsShowME(true)
        }
    }, [companyRequests])

    const confirmUser = async (user) => {
        console.log(user)
        hideConfirmDia()
        const { data } = await callAPI(
            `/building/${user.requestId ? user.requestId : user.id}/ApproveProjectJoinRequest`,
            {},
            "POST",
            {
                id: user.requestId ? user.requestId : user.id,
                companyId: user.company_id,
            }
        );
        $crud.notify({
            type: data.status ? "success" : "error",
            message: data.message,
        });
        if (data.status) {
            // Invalidate activity messages cache to trigger reload of latest messages
            dispatch({ type: SET_ACTIVITY_MESSAGES_LAST_FETCHED, payload: 0 });
        }
        if (isShowME) {
            const updatedUsers = Myusers.filter(u => u.id !== user?.id);
            setMyUsers(updatedUsers);
        }
        setSelectedUser(null)
    }
    const removeUser = async (user) => {
        hideConfirmDia()
        const { data } = await callAPI(
            `/building/${user.requestId ? user.requestId : user.id}/RejectProjectJoinRequest`,
            {},
            "POST",
            {
                id: user.requestId ? user.requestId : user.id,
                companyId: user.company_id,
            }
        );
        $crud.notify({
            type: data.status ? "success" : "error",
            message: data.message,
        });
        if (isShowME) {
            const updatedUsers = Myusers.filter(u => u.id !== user?.id);
            setMyUsers(updatedUsers);
        }
        setSelectedUser(null)
    }
    const [showPositionDialog, setPositionDialog] = useState(false);
    const hidePositionDialog = () => setPositionDialog(false);
    const [showConfirmDia, setConfirmDia] = useState(false);
    const hideConfirmDia = () => setConfirmDia(false);

    const handleSubmit = async (type) => {
        if (type == 'reject') {
            removeUser(selectedUser)
        }
        else {
            confirmUser(selectedUser)
        }
    }

    const onConfirmClick = (user) => {
        // setEmployeePosition(null)
        // setSelectedUser(user)
        // setPositionDialog(true)
        confirmUser(user)
    }

    const onRejectClick = (user) => {
        // setEmployeePosition(null)
        // setSelectedUser(user)
        // setConfirmDia(true)
        removeUser(user)
    }

    const handleCloseXX = () => {
        setIsShowME(false)
        if (users.length > 0) {
            setIsShowCompany(true)
        }
        else {
            handleClose()
        }
    }


    return (
        <>
            {Myusers.length > 0 &&
                <div className="backdrop rejoin-users" >
                    <div className="role_popup shadow-sm rejoin-users__popup">
                        <h4>{strings.request_to_join_a_room}</h4>
                        <div className="rejoin-users__list">
                            {
                                Myusers.map((user, index) => (
                                    <div className="m-0 rejoin-users__row" key={index}>
                                        <div className="rejoin-users__avatar">
                                            <UserAvatar
                                                width={48}
                                                height={48}
                                                src={(user.img || user.avatar) ? BASE_URL + (user.img || user.avatar) : null}
                                                alt={user.user}
                                                fallbackSrc={process.env.PUBLIC_URL + "/assets/img/head.svg"}
                                                isKjuup={user.isKjuup || user.companies?.some(c => c.isKjuup)}
                                            />
                                        </div>
                                        <div>
                                            <div className="rejoin-users__line">
                                                <span
                                                    className="rejoin-users__text"
                                                    dangerouslySetInnerHTML={{
                                                        __html: strings.wants_to_rejoin_room
                                                            .replace("Username", `<strong>${user.user}</strong>`)
                                                            .replace("Roomname", `<strong>${user.buildingName}</strong>`),
                                                    }}
                                                />
                                                <span className="rejoin-users__actions">
                                                    <button type="button" onClick={e => onConfirmClick(user)} className="kj-btn kj-btn--icon kj-btn--lg kj-btn--round kj-btn--internal" aria-label="Accept Request">
                                                        <MaterialIcon icon="check" size={24} color="green" />
                                                    </button>
                                                    <button type="button" onClick={e => onRejectClick(user)} className="kj-btn kj-btn--icon kj-btn--lg kj-btn--round kj-btn--danger ml-2" aria-label="Delete Request">
                                                        <MaterialIcon icon="close" size={24} color="red" />
                                                    </button>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                        <div className="bottom-button">
                            <a className="pointer" onClick={handleCloseXX}>{strings.close}</a>
                        </div>
                    </div>
                    <Modal
                        show={showPositionDialog}
                        onHide={hidePositionDialog}
                        animation={false}
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>{strings.your_position_within_company}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <ListGroup variant="flush">
                                {Positions.map((position) => (
                                    <div
                                        onClick={(e) => setEmployeePosition(position.name_en)}
                                        key={position.id}
                                        className="form-check p"
                                    >
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="exampleRadios"
                                            id={position.id}
                                            value={position.name_en}
                                        />
                                        <label
                                            className="form-check-label pointer"
                                            htmlFor={position.id}
                                        >
                                            {isGerm ? position.name_de : position.name_en}
                                        </label>
                                    </div>
                                ))}
                            </ListGroup>
                        </Modal.Body>
                        <Modal.Footer>
                            <button type="button" className="kj-btn kj-btn--outline" onClick={() => {
                                setConfirmDia(true)
                            }}>
                                {strings.close_modal}
                            </button>
                            <button type="button" className="kj-btn kj-btn--outline"
                                onClick={handleSubmit}
                            >
                                Ok
                            </button>
                        </Modal.Footer>
                    </Modal>
                    <Modal
                        show={showConfirmDia}
                        onHide={hideConfirmDia}
                        animation={false}
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>{strings.confirm}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <p>{strings.refuse_company}</p>
                        </Modal.Body>
                        <Modal.Footer>
                            <button type="button" className="kj-btn kj-btn--outline" onClick={hideConfirmDia}>
                                {strings.cancel}
                            </button>
                            <button type="button" className="kj-btn kj-btn--outline"
                                onClick={() => handleSubmit('reject')}
                            >
                                Ok
                            </button>
                        </Modal.Footer>
                    </Modal>
                </div>
            }
        </>

    )
}

const mapStateToProps = (state) => {
    const {
        openProjects,
        updateProjectActionFire,
        projects,
        groupChats,
        forwardGroupMessages,
        draftMessages,
        updateGroupMessage,
        isOpenByOwner,
    } = state;
    return {
        projects: projects,
        openProjects: openProjects,
        updateProjectActionFire: updateProjectActionFire,
        groupChats: groupChats,
        forwardGroupMessages: forwardGroupMessages,
        draftMessages: draftMessages,
        updateGroupMessage: updateGroupMessage,
        isOpenByOwner,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        updateProjectAction: (value) =>
            dispatch({
                type: UPDATE_PROJECT_ACTION_FIRE,
                updateProjectActionFire: value,
            }),

    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(memo(RejoinUsersDialoge)));